import { useAppSelector } from "../../../../services/redux/hooks/use-selector";
import { useTimer } from "../../hooks/use-timer";
import { selectSchemaTimerById } from "../../redux/selectors";
import styles from "./styles.module.css";

interface Props {
  objectId: string;
}

export const SchemaTimer = ({ objectId }: Props) => {
  const timer = useAppSelector((state) =>
    selectSchemaTimerById(state, objectId),
  );

  const remainingMs = useTimer(
    timer?.status === "loading" ? timer?.startedAt : null,
    timer?.estimatedMs ?? 0,
  );

  if (timer?.status !== "loading") return null;

  const totalSeconds = Math.ceil(remainingMs / 1000);
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;

  const formatted = `${minutes}:${String(seconds).padStart(2, "0")}`;

  return (
    <div className={styles.timer}>
      Приблизительное время обработки составляет 3 минуты:{" "}
      <strong>{formatted}</strong>
    </div>
  );
};
